export default {
  forgotPasword: 'components.views.reset-password-view.email-sent.email-sent',
  checkEmail: 'components.views.reset-password-view.email-sent.check-email'
}
